"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTopUserInfo = void 0;
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_1 = __importDefault(require("react"));
var AccountCircleOutlined_1 = __importDefault(require("@material-ui/icons/AccountCircleOutlined"));
var AppTop_styles_1 = require("./AppTop.styles");
exports.AppTopUserInfo = react_1.default.memo(function (_a) {
    var username = _a.username, clickAction = _a.clickAction;
    return (react_1.default.createElement("div", { style: AppTop_styles_1.userInfo },
        react_1.default.createElement(AccountCircleOutlined_1.default, { style: AppTop_styles_1.userInfoIcon, onClick: clickAction }),
        ' ',
        react_1.default.createElement(Typography_1.default, { variant: "body2", style: AppTop_styles_1.userInfoText, onClick: clickAction }, username)));
});
exports.AppTopUserInfo.displayName = 'AppTopUserInfo';
exports.default = exports.AppTopUserInfo;
//# sourceMappingURL=AppTopUserInfo.js.map